<ion-app>
  <app-version-banner></app-version-banner>
  <app-environment-banner></app-environment-banner>
  <ion-router-outlet id="main"></ion-router-outlet>
  <div class="preloadArea"></div>
</ion-app>
